/**
 * One-shot localStorage migration: sage_* → aanar_*.
 *
 * Rebrand from Sage to Aanar renamed a couple of client-side keys. Rather than
 * force users to re-set their preferences (referral code, ChartCopilot beginner
 * mode) we copy each old key into its new name once, then delete the old key.
 *
 * A `migrated_to_aanar` guard flag ensures this only runs once per browser.
 * Safe to import multiple times — early-return short-circuits.
 */
const KEY_MAP = {
  sage_token: "aanar_token",                        // Kept for forward-compat if ever added
  sage_theme: "aanar_theme",                        // Kept for forward-compat
  sage_referral_code: "aanar_referral_code",
  sage_copilot_beginner: "aanar_copilot_beginner",
};

const GUARD = "aanar_ls_migrated";

export function migrateLocalStorage() {
  try {
    if (typeof window === "undefined" || !window.localStorage) return;
    if (localStorage.getItem(GUARD) === "1") return;
    for (const [oldKey, newKey] of Object.entries(KEY_MAP)) {
      const oldVal = localStorage.getItem(oldKey);
      if (oldVal === null) continue;
      // Don't clobber a value already written under the new key.
      if (localStorage.getItem(newKey) === null) {
        localStorage.setItem(newKey, oldVal);
      }
      localStorage.removeItem(oldKey);
    }
    localStorage.setItem(GUARD, "1");
  } catch {
    // Access to localStorage may throw in private mode / sandboxed frames — skip silently.
  }
}
